import { ChannelSchema, Storage } from '@feedyou/schema'
import { isNotEmptyElement } from '@feedyou/utils'

export const extractWebchatUserDataStorages = (
  channels: ChannelSchema[] | undefined
): Storage[] => {
  if (!channels) {
    return []
  }

  return channels
    .filter(isWebchatChannel)
    .map(channel => channel.userData)
    .flat()
    .filter(isNotEmptyElement)
    .map(data => {
      return {
        name: data?.storage?.toLowerCase(),
        value: data?.value,
        storageType: ['webchat user data']
      }
    })
}

type WebchatChannelSchema = Extract<ChannelSchema, { type: 'webchat' }>

const isWebchatChannel = (channel: ChannelSchema): channel is WebchatChannelSchema => {
  return channel.type === 'webchat'
}
